module.exports = __webpack_public_path__ + "static/img/product-6.528eca2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-6.png
// module id = +JCz
// module chunks = 0